var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fof"},[_c('img',{attrs:{"src":require("../assets/img/404.png"),"alt":""}}),_c('p',[_vm._v("会话失效，请关闭 app 重新打开")])])
}]

export { render, staticRenderFns }